module.exports = __webpack_public_path__ + "static/Personalize-Patient-Engagement-90280156ef4161fdfebe75694f0ec62a.jpg";